import React from "react";
// @mui material components

import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import Button from "@mui/material/Button";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import SuiTypography from "components/SuiTypography";
import Createable from "containers/Select";

const activeOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

function SuperAdminSearch({
  setFilterQuery,
  filterQuery,
  filterHandler,
  resetHandler,
}) {
  return (
    <SuiBox
      display="flex"
      justifyContent="space-between"
      flexWrap="wrap"
      alignItems="end"
      style={{ padding: "0 24px" }}
    >
      <SuiBox
        mt={1}
        style={{
          display: "flex",
          justifyContent: "flex-between",
          alignItems: "end",
          flexWrap: "wrap",
        }}
      >
        <SuiBox mb={1} mr={2.5}>
          <SuiTypography mb={1} variant="h6">
            From Date
          </SuiTypography>
          <DatePicker
            isClearable
            closeOnScroll={true}
            selected={filterQuery?.fromDate}
            onChange={(date) => {
              setFilterQuery({
                ...filterQuery,
                fromDate: date,
              });
            }}
            className="date-picker-custom-v2"
            placeholderText="From date"
          />
        </SuiBox>

        <SuiBox mb={1} mr={2.5}>
          <SuiTypography mb={1} variant="h6">
            To Date
          </SuiTypography>
          <DatePicker
            isClearable
            closeOnScroll={true}
            selected={filterQuery?.toDate}
            onChange={(date) => {
              setFilterQuery({
                ...filterQuery,
                toDate: date,
              });
            }}
            className="date-picker-custom-v2"
            placeholderText="To date"
          />
        </SuiBox>

        <SuiBox mb={1} mr={2.5} width="20%">
          <SuiTypography mb={1} variant="h6">
            Status
          </SuiTypography>
          <Createable
            options={activeOptions}
            style={{ borderRadius: "0.5rem", fontSize: 14 }}
            inputStyle={{
              width: 190,
              height: "1.850rem",
              borderRadius: "0.5rem",
            }}
            onChange={(e) => {
              setFilterQuery({
                ...filterQuery,
                status: e,
              });
            }}
            value={filterQuery?.status}
          />
        </SuiBox>

        <SuiBox my={1} mb={1} mr={2.5}>
          <SuiButton
            component={Button}
            color="dark"
            variant="gradient"
            onClick={filterHandler}
          >
            Search
          </SuiButton>
        </SuiBox>
      </SuiBox>

      <SuiBox mb={1} mr={2.5}>
        <SuiButton
          component={Button}
          color="dark"
          variant="gradient"
          style={{
            color: "#3A416F",
          }}
          onClick={() => {
            resetHandler();
          }}
        >
          Reset
        </SuiButton>
      </SuiBox>
    </SuiBox>
  );
}

export default SuperAdminSearch;
